import { get } from 'lodash';

const root = state => get(state, 'InventoryBasicSetupState');
export const getLoadingSetUp = state => get(root(state), 'loadingSetUp', false);
export const getSetUpData = state => get(root(state), 'setUpData', []);
export const getLoadingSetUpError = state =>
  get(root(state), 'loadingSetUpError', null);
export const getIsSetUpSubmitting = state =>
  get(root(state), 'isSetUpSubmitting', false);
export const getSubmitted = state => get(root(state), 'submitted', false);
export const getSubmitError = state => get(root(state), 'submitError', null);
export const getSubmitSuccessMsg = state =>
  get(root(state), 'submitSuccessMsg', '');



// WEBPACK FOOTER //
// ./src/pages/inventory/inventorybasicsetup/state/selectors.js